import { render, staticRenderFns } from "./Calendar3.vue?vue&type=template&id=4525f212"
import script from "./Calendar3.vue?vue&type=script&lang=js"
export * from "./Calendar3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports